import mitt from 'mitt'

import { ASYNC_MODAL_OPEN_EVENTS, V3_TO_V2_BUFFERED_EVENTS } from './eventContract'

const MAX_BUFFERED_PER_EVENT = 10
const BUFFERED_EVENTS = new Set([...V3_TO_V2_BUFFERED_EVENTS, ...ASYNC_MODAL_OPEN_EVENTS])

const createBufferedBus = () => {
  const bus = mitt()
  const pending = new Map()

  const emit = (type, payload) => {
    const handlers = bus.all.get(type)
    if (!handlers?.length && BUFFERED_EVENTS.has(type)) {
      const queue = pending.get(type) ?? []
      queue.push(payload)
      pending.set(type, queue.slice(-MAX_BUFFERED_PER_EVENT))
    }
    bus.emit(type, payload)
  }

  const on = (type, handler) => {
    bus.on(type, handler)
    const queue = pending.get(type)
    if (queue) {
      pending.delete(type)
      queue.forEach(payload => {
        try {
          handler(payload)
        } catch (error) {
          console.error(`[eventBus] replay handler failed for "${type}"`, error)
        }
      })
    }
  }

  return { ...bus, on, emit }
}

const globalEventBus = globalThis.__EVENT_BUS__ || createBufferedBus()
globalThis.__EVENT_BUS__ = globalEventBus

export default globalEventBus
